import {map} from "underscore";

export const getSessions = async (apiClient, {email, limit, cursor}) => {
  return apiClient.post("/v1/sessions/list", {
    email,
    sessionType: "trustedAdvisor",
    ...(limit && {limit}),
    ...(cursor && {cursor}),
  });
};

export const deleteSession = async (apiClient, {sessionId, email}) => {
  return apiClient.delete(`/v1/sessions/${sessionId}`, {
    email,
    sessionType: "trustedAdvisor",
  });
};

export const renameSession = async (apiClient, {sessionId, sessionName, email}) => {
  return apiClient.post(`/v1/sessions/${sessionId}/rename`, {
    email,
    sessionName,
    sessionType: "trustedAdvisor",
  });
};

export const setLastViewed = async (apiClient, {sessionId, email, timestamp}) => {
  return apiClient.post(`/v1/sessions/${sessionId}/set-last-viewed`, {
    email,
    timestamp,
    sessionType: "trustedAdvisor",
  });
};

export const setSessionPinned = async (apiClient, {sessionId, pinned}) =>
  apiClient.post(`/v1/sessions/${sessionId}/set-pinned`, {pinned});

export const checkSessionActivity = async (apiClient, {email, sessionId}) => {
  return apiClient.post("/v1/sessions/pending", {
    email,
    currentSessionId: sessionId,
    sessionType: "trustedAdvisor",
  });
};

export const getSessionShares = async (apiClient, {sessionId, historyCursor}) =>
  apiClient.post("/v1/sessions/shares/list", {sessionId, historyCursor});

export const shareSession = async (apiClient, {sessionId, userIds}) =>
  apiClient.post(`/v1/sessions/${sessionId}/shares`, {
    targets: map(userIds, (userId) => ({userId})),
  });

export const revokeSessionShare = async (apiClient, {sessionId, userId}) =>
  apiClient.delete(`/v1/sessions/${sessionId}/shares/${userId}`);

export const leaveSession = async (apiClient, {sessionId}) =>
  apiClient.post(`/v1/sessions/${sessionId}/leave`, {});
